import * as LabelPrimitive from '@radix-ui/react-label';
import {cva, type VariantProps} from 'class-variance-authority';
import * as React from 'react';

import {cn} from '../lib/utils';

const labelVariants = cva('items-center justify-center', {
    variants: {
        variant: {
            default: 'text-[#000000]',
            success: 'text-[#067647] bg-[#ECFDF3] border border-[1px] border-[#067647]',
            error: 'text-[#B42318] bg-[#FEF3F2] border border-[1px] border-[#FECDCA] px-[20px]',
            outline: 'border border-input bg-background hover:bg-accent hover:text-accent-foreground',
        },
        size: {
            default: 'px-[6px] py-[2px] rounded-[6px] font-[500] text-[12px]',
            sm: 'px-[6px] py-[2px] rounded-[6px] font-[500] text-[12px]',
            md: 'px-[8px] py-[2px] rounded-[6px] font-[500] text-[14px]',
            lg: 'px-[10px] py-[2px] rounded-[6px] font-[500] text-[14px]',
        },
    },
    defaultVariants: {
        variant: 'default',
        size: 'default',
    },
});

const Label = React.forwardRef<
    React.ElementRef<typeof LabelPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> & VariantProps<typeof labelVariants>
>(({className, variant, size, ...props}, ref) => (
    <LabelPrimitive.Root ref={ref} className={cn(labelVariants({variant, size}), className)} {...props} />
));
Label.displayName = LabelPrimitive.Root.displayName;

export {Label};
